import Social from '@r1-frontend/ui-react/components/buttons/social';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

import { CONTENT_CDN } from '~/src/constants';
import { ddmmmmyyyy } from '~/src/helpers/date';
import NoSSR from '~/src/helpers/noSSR';
import { clearHTMLTags, clearNbsp } from '~/src/helpers/string';

import { ActualNews } from '../actual-news';
import { TagsLinks } from '../tags-links';
import * as ST from './styled';

const DESCRIPTION_LENGTH = 140;

const getSchemaMarkedText = text => {
    return (
        <ST.DetailText  itemProp='about' itemScope itemType='https://schema.org/Thing'
            dangerouslySetInnerHTML={{
                __html: text,
            }}
        />
    );
};

const getShareText = (service, title, description, imageURL) => {
    const url = window.location.href;
    const str =
        `https://share.yandex.net/go.xml?service=${service}&url=${url}&title=${title}&description=${description}&image=${imageURL}', '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes`;
    window.open(str);
};

const getSocialConfig = (title, text, imageURL) => {
    // TODO: Fix later in https://ticket.ertelecom.ru/browse/WEB-43177
    const description = clearNbsp(clearHTMLTags(text))
        .substr(0, DESCRIPTION_LENGTH) + '...';
    return (
        {
            vk: {
                click: () => getShareText('vkontakte', title, description, imageURL),
            },
            odn: {
                click: () => getShareText('odnoklassniki', title, description, imageURL),
            },
        }
    );
};

export const DetailNews = ({ item, actualNews, hostname, cityIn }) => {
    const { alias, title, text, image, active_from, tags, host } = item;
    const imageURL = host + image;
    const newsDate = ddmmmmyyyy(new Date(active_from));

    return (
        <ST.DetailNews itemScope itemType='http://schema.org/NewsArticle'>

            <meta itemProp='identifier' content='123'/>
            <meta itemProp='author' content='Дом.ру'/>
            <meta itemScope itemProp='mainEntityOfPage' itemType='https://schema.org/WebPage' itemID={`https://${hostname}.dom.ru/news/${alias}`}/>

            <ST.GrayWrap>
                <ST.InnerWrap isGray={true}>
                    <ST.DetailCrumbsWrap>
                        <Link
                            href={'/news'}
                            as={'/news'}
                            scroll={false}
                            passHref
                        >
                            <ST.DetailCrumb>Новости</ST.DetailCrumb>
                        </Link>
                        <ST.Sepatator>/</ST.Sepatator>
                        <Link
                            href={'/news/[alias]'}
                            as={`/news/${alias}`}
                            scroll={false}
                            passHref
                        >
                            <ST.DetailCrumb>{title}</ST.DetailCrumb>
                        </Link>
                    </ST.DetailCrumbsWrap>
                </ST.InnerWrap>
            </ST.GrayWrap>

            <ST.InnerWrap>
                <ST.DetailContent>
                    <ST.DetailDate>{newsDate}</ST.DetailDate>

                    <meta itemProp='datePublished' content={active_from.split(' ')[0]}/>
                    <meta itemProp='dateModified' content={active_from.split(' ')[0]}/>

                    <ST.DetailTitle itemProp='headline'>{title}</ST.DetailTitle>

                    <div itemProp='publisher' itemScope itemType='https://schema.org/Organization'>
                        <ST.DetailLogoWrap itemProp='logo image' itemScope itemtype={'https://schema.org/ImageObject'}>
                            <div itemProp='name'>{title}</div>
                            <img itemProp='contentUrl' src={`${CONTENT_CDN}/files/admin/cityDomain/image/39579_1646292984.svg`} alt='logo'/>
                            <span itemProp='description'>{`${title}. Анонсы кинопремьер, конкурсов и других событий. ` +
                                `Актуальные новости и акции провайдера Дом.ру в ${cityIn}`}
                            </span>
                            <meta itemProp='width' content='6'/>
                            <meta itemProp='height' content='6'/>
                        </ST.DetailLogoWrap>
                        <meta itemProp='name' content='Дом.ру'/>
                    </div>

                    <ST.DetailPictureWrap>
                        <ST.DetailPicture src={imageURL} alt={title}  itemProp='image'/>
                    </ST.DetailPictureWrap>

                    <ST.DetailDescription itemProp='articleBody'>
                        {getSchemaMarkedText(text)}
                    </ST.DetailDescription>

                    <ST.DetailTagsWrap>
                        <TagsLinks options={tags}/>
                    </ST.DetailTagsWrap>

                    <ST.SocialWrap>
                        <NoSSR>
                            <Social socials={getSocialConfig(title, text, imageURL)}/>
                        </NoSSR>
                    </ST.SocialWrap>
                </ST.DetailContent>
            </ST.InnerWrap>

            <NoSSR>
                <ST.GrayWrap>
                    <ST.InnerWrap isGray={true}>
                        <ActualNews actualNews={actualNews}/>
                    </ST.InnerWrap>
                </ST.GrayWrap>
            </NoSSR>
        </ST.DetailNews>
    );
};

DetailNews.propTypes = {
    item: PropTypes.shape({
        alias: PropTypes.string,
        title: PropTypes.string,
        text: PropTypes.string,
        image: PropTypes.string,
        active_from: PropTypes.string,
        tags: PropTypes.array,
    }).isRequired,
    actualNews: PropTypes.array,
};

DetailNews.defaultProps = {
    actualNews: [],
};
